import { awIntegrationsApi } from './Base';
import { AGraphDocumentLinksBySecuritiesPayload, AGraphDocumentLinksBySecuritiesResponse } from './types';

export const BASE_DOCUMENTS_PATH = `/partners/documents/v1/documents:batchGet`;
export function getDocumentLinksBySecurities(payload: AGraphDocumentLinksBySecuritiesPayload) {
  return awIntegrationsApi.post<AGraphDocumentLinksBySecuritiesResponse>(BASE_DOCUMENTS_PATH, payload);
}

export function getDocumentByURI(uri: string) {
  return fetch(uri);
}
